import { FunctionComponent } from "react";
import { LoginForm } from "src/components/forms";
import { PageContainer, PageTitle } from "src/components/generic";
import TopNav from "src/components/navigation/TopNav";

const Login: FunctionComponent = () => (
    <PageContainer>
        <div className="px-3">
            <TopNav />
        </div>
        <div>
            <PageTitle title="Login" />

            <LoginForm />
        </div>
    </PageContainer>
);

export default Login;